import { FiTag, FiChevronRight } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import usePlaylist from "../../../hooks/usePlaylist";

const PlayLists = () => {
  const navigate = useNavigate();
  const { loading, courses } = usePlaylist();

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="w-8 h-8 border-2 border-[#0f6abf] border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  if (courses.length === 0) {
    return (
      <div className="min-h-screen px-4 md:px-8 py-6">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
            <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
            </svg>
          </div>
          <h1 className="text-xl font-semibold text-gray-900">PlayList (Your Free Courses)</h1>
        </div>
        <div className="text-center py-16 bg-white rounded-2xl border border-gray-200">
          <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
            </svg>
          </div>
          <p className="text-gray-500">No courses added to your playlist yet.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen px-4 md:px-8 py-6">
      <div className="flex items-center gap-3 mb-8">
        <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
          <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
          </svg>
        </div>
        <h1 className="text-xl font-semibold text-gray-900">PlayList (Your Free Courses)</h1>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {courses.map((courseItem) => {
          const course = courseItem.data;
          const course_id = courseItem.course_id;
          const user = course.teacher.user;

          return (
            <div
              key={courseItem.id}
              className="bg-white rounded-2xl border border-gray-200 shadow-sm hover:shadow-md hover:-translate-y-1 transition-all flex flex-col overflow-hidden"
            >
              {/* Thumbnail */}
              <div className="w-full h-48 overflow-hidden">
                <img
                  src={course.image}
                  alt={course.name}
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Content */}
              <div className="p-5 flex flex-col flex-1">
                {/* Course Name */}
                <div className="flex items-start gap-2 mb-3">
                  <h2 className="text-lg font-semibold text-gray-900">
                    {course.name}
                  </h2>
                </div>

                {/* Description */}
                <p className="text-sm text-gray-600 leading-relaxed mb-4 flex-1">
                  {course.description.length > 200
                    ? course.description.slice(0, 200) + "..."
                    : course.description}
                </p>

                {/* Price Badge */}
                <div className="mb-4">
                  <span className="inline-flex px-3 py-1.5 bg-[#e8f0f7] text-[#0f6abf] text-sm font-medium rounded-lg">
                    {course.course_type === "free" ? "Free" : `$${course.price}`}
                  </span>
                </div>

                {/* Category / Subcategory */}
                {/* <div className="flex items-center gap-2 p-3 bg-gray-50 rounded-xl mb-4">
                  <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
                    <FiTag className="w-4 h-4 text-[#0f6abf]" />
                  </div>
                  <div className="flex items-center text-sm text-gray-700">
                    <span className="font-medium">{course.category_name}</span>
                    <FiChevronRight className="w-3 h-3 text-gray-400 mx-1" />
                    <span>{course.subcategory_name}</span>
                  </div>
                </div> */}

                {/* Teacher Info */}
                {user && (
                  <div className="flex items-center gap-3 p-3 bg-gray-50 rounded-xl mb-4">
                    <div className="relative">
                      <img
                        src={user?.profile_image}
                        alt={user.name}
                        className="w-10 h-10 rounded-lg object-cover border-2 border-white shadow-sm"
                      />
                      {/* <div className="absolute -bottom-1 -right-1 w-2.5 h-2.5 bg-green-500 rounded-full border-2 border-white"></div> */}
                    </div>
                    <div>
                      <h6 className="text-sm font-medium text-gray-900">{user?.name}</h6>
                      <p className="text-xs text-gray-500">{user.email}</p>
                    </div>
                  </div>
                )}

                {/* Watch Button */}
                <button
                  onClick={() => navigate(`/student/playlist/${course_id}`)}
                  className="mt-auto w-full py-3 bg-[#0f6abf] text-white text-sm font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors flex items-center justify-center gap-2"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  Watch Now
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PlayLists;